export const sliderMinimumSlides = (items: any[], minSlides: number) => {
  let _tempArray = items
  while (_tempArray.length < minSlides * 2) {
    _tempArray = _tempArray.concat(_tempArray)
  }
  return _tempArray
}
